import {
  SET_BUSINESS_TYPES,
  SET_BREADCRUMB_LINKS,
  SET_PRODUCT_TYPES,
} from 'shared/constants/ActionTypes';

const initialSettings = {
  businessTypes: [],
  breadCrumbLinks: [],
};

const configReducer = (state = initialSettings, action) => {
  switch (action.type) {
    case SET_BUSINESS_TYPES:
      return {
        ...state,
        businessTypes: action.payload,
      };
    case SET_PRODUCT_TYPES:
      return {
        ...state,
        productTypes: action.payload,
      };
    case SET_BREADCRUMB_LINKS:
      return {
        ...state,
        breadCrumbLinks: action.payload,
      };
    default:
      return state;
  }
};

export default configReducer;
